<div class="modal">
  <app-modal-header
    title="sign_off"
    [customClose]="true"
    [disabledCloseButton]="isSyncing()"
    (closeEventEmitter)="close()" />
  <div class="modal-content">
    <p>
      {{ 'sign_off_warning' | uvetranslate }}
    </p>
    @if (openActivities() > 0) {
      <app-warning-alert-message
        icon="assets/icon/triangle-exclamation-solid.svg"
        [color]="WarningAlertColor.YELLOW"
        [enableClick]="true">
        {{ 'warning_open_activities' | uvetranslate }}
        <ion-button
          fill="clear"
          mode="md"
          class="no-ripple btn-see-more"
          [disabled]="isSyncing()"
          (click)="showOpenActivities()">
          {{ 'see' | uvetranslate | titlecase }}
        </ion-button>
      </app-warning-alert-message>
    }
    @if (networkService.isOnline()) {
      <div class="sync-containter">
        @if (!syncDone && !syncRestService.synchronizing) {
          <div class="sync">
            <ion-button
              class="primary"
              [disabled]="callingLogoutAction || syncError || !networkService.isOnline()"
              (click)="sync()">
              <ion-icon src="/assets/icon/sync.svg" (click)="sync()" />
              <span>
                {{ 'sync_up' | uvetranslate }}
              </span>
            </ion-button>
          </div>
        }
        @if (syncRestService.synchronizing) {
          <div class="synchronizing">
            <ion-spinner name="crescent" />
            <span>
              {{ 'sending_data' | uvetranslate }}
            </span>
          </div>
          <div class="synchronizing">
            {{ 'records_processed' | uvetranslate }}: {{ syncService.numDocProcessed() }}/{{ syncService.totalDocs() }}
          </div>
        }
        @if (syncDone && !syncError) {
          <div class="state-msg">
            <ion-icon class="success" src="assets/icon/cloud-check.svg" />
            {{ 'sync_complete' | uvetranslate }}
          </div>
        }
        @if (syncError) {
          <div class="state-msg">
            <ion-icon class="error" src="assets/icon/cloud-check.svg" />
            {{ 'data_unsuccessful_synchronized' | uvetranslate }}
          </div>
        }
      </div>
    }
  </div>

  <div class="modal-footer" [class.custom-item-disabled]="!networkService.isOnline()">
    @if (!syncRestService.synchronizing) {
      <app-button-action
        textCallingAction="logging_out"
        [text]="!syncDone ? 'no_sync_sign_off' : 'sign_off'"
        [dataQaIdentifier]="!syncDone ? 'logout-btn1' : 'logout-btn2'"
        [callingAction]="callingLogoutAction"
        (handleClick)="logout()" />
    }
  </div>
</div>
